<section class="support-material">

  <h2 id="product-support-material-title" class="container">Materiais de apoio</h2>

  <ul>
    <li class="item" *ngFor="let item of data.support_materials; let i = index">
      <span class="text">
        <img src="assets/svgs/red-pdf.svg" alt="">
        <span>{{item.name | titlecase}} ({{item.type | uppercase}})</span>
      </span>
      <a [id]="item.type + '-' + i" [href]="item.url" target="_blank">
        <img src="assets/svgs/download.svg" alt="">
      </a>
    </li>
  </ul>
</section>